// extracted by mini-css-extract-plugin
export default {"toast":"social-blocks-BlockUserModal__toast--2EGdI"};